import { ApiError } from './api';
import { useToastStore } from '../stores/toast';

export function toastOk(message: string): void {
  useToastStore.getState().push(message, 'ok');
}

export function toastError(error: unknown, fallback: string): void {
  const message = error instanceof ApiError ? error.message : fallback;
  useToastStore.getState().push(message, 'danger');
}
